export default "__VITE_ASSET__vBkXFt1n__"